export const docMeta = {
    s1: {
        claimsEE: {
            english: [
                {
                    label: 'Authorization forms',
                    value: 'Authorization forms',
                    type: 'EMP',
                    title: 'AUTH',
                },
                {
                    label: 'Employee signed forms',
                    value: 'Employee signed forms',
                    type: 'EMP',
                    title: 'FORM',
                    isRtwEligible: true,
                },
                {
                    label: 'Doctor signed forms',
                    value: 'Doctor signed forms',
                    type: 'MED',
                    title: 'FRMTRTNGPVDR',
                    isRtwEligible: true,
                },
                {
                    label: 'Medical records',
                    value: 'Medical records',
                    type: 'MED',
                    title: 'MEDREC',
                    isRtwEligible: true,
                },
                {
                    label: 'Appeal letter',
                    value: 'Appeal letter',
                    type: 'APPL',
                    title: 'NTCEAPPL',
                },
                {
                    label: 'Other non-medical documentation',
                    value: 'Other non-medical documentation',
                    type: 'EMP',
                    title: 'CORR',
                    isRtwEligible: true,
                },
            ],
            spanish: [
                {
                    label: 'Formularios de autorización',
                    value: 'Formularios de autorización',
                    type: 'EMP',
                    title: 'AUTH',
                },
                {
                    label: 'Formularios firmados por los empleados',
                    value: 'Formularios firmados por los empleados',
                    type: 'EMP',
                    title: 'FORM',
                    isRtwEligible: true,
                },
                {
                    label: 'Formularios firmados por el médico',
                    value: 'Formularios firmados por el médico',
                    type: 'MED',
                    title: 'FRMTRTNGPVDR',
                    isRtwEligible: true,
                },
                {
                    label: 'Registros médicos',
                    value: 'Registros médicos',
                    type: 'MED',
                    title: 'MEDREC',
                    isRtwEligible: true,
                },
                {
                    label: 'Carta de apelación',
                    value: 'Carta de apelación',
                    type: 'APPL',
                    title: 'NTCEAPPL',
                },
                {
                    label: 'Otra documentación no médica',
                    value: 'Otra documentación no médica',
                    type: 'EMP',
                    title: 'CORR',
                    isRtwEligible: true,
                },
            ],
        },
        claimsER: {
            english: [
                {
                    label: 'Job description',
                    value: 'Job description',
                    type: 'EPR',
                    title: 'JOBDES'
                },
                {
                    label: 'Eligibility information',
                    value: 'Eligibility information',
                    type: 'EPR',
                    title: 'EPRELIG',
                },
                {
                    label: 'Employee signed forms',
                    value: 'Employee signed forms',
                    type: 'EMP',
                    title: 'FORM'
                },
                {
                    label: 'Medical records',
                    value: 'Medical records',
                    type: 'MED',
                    title: 'MEDREC'
                },
                {
                    label: 'Other non-medical documentation',
                    value: 'Other non-medical documentation',
                    type: 'EPR',
                    title: 'CORR',
                    isRtwEligible: true,
                }
            ],
            spanish: [
                {
                    label: '',
                    type: '',
                    title: ''
                },
            ]
        },
        leaves: {
            english: [
                {
                    label: 'Medical certification form',
                    value: 'Medical certification form',
                    type: 'LVE',
                    title: 'MEDCERT',
                },
                {
                    label: 'Proof of birth',
                    value: 'Proof of birth',
                    type: 'LVE',
                    title: 'BRTHCERT',
                },
                {
                    label: 'Adoption/Foster care certification',
                    value: 'Adoption/Foster care certification',
                    type: 'LVE',
                    title: 'ADPTCERT',
                },
                {
                    label: 'Other correspondence',
                    value: 'Other correspondence',
                    type: 'LVE',
                    title: 'MISCCORR',
                    isRtwEligible: true,
                },
            ],
            spanish: [
                {
                    label: 'Formulario de certificación médica',
                    value: 'Formulario de certificación médica',
                    type: 'LVE',
                    title: 'MEDCERT',
                },
                {
                    label: 'Prueba de nacimiento',
                    value: 'Prueba de nacimiento',
                    type: 'LVE',
                    title: 'BRTHCERT',
                },
                {
                    label: 'Certificación de adopción/cuidado de crianza',
                    value: 'Certificación de adopción/cuidado de crianza',
                    type: 'LVE',
                    title: 'ADPTCERT',
                },
                {
                    label: 'Otra correspondencia',
                    value: 'Otra correspondencia',
                    type: 'LVE',
                    title: 'MISCCORR',
                    isRtwEligible: true,
                },
            ],
        },
        coordinatedEE: {
            english: [
                {
                    label: 'Authorization forms',
                    value: 'Authorization forms',
                    type: 'EMP',
                    title: 'AUTH',
                },
                {
                    label: 'Employee signed forms',
                    value: 'Employee signed forms',
                    type: 'EMP',
                    title: 'FORM',
                },
                {
                    label: 'Doctor signed forms',
                    value: 'Doctor signed forms',
                    type: 'MED',
                    title: 'FRMTRTNGPVDR',
                },
                {
                    label: 'Medical records',
                    value: 'Medical records',
                    type: 'MED',
                    title: 'MEDREC',
                    isRtwEligible: true,
                },
                {
                    label: 'Other non-medical documentation',
                    value: 'Other non-medical documentation',
                    type: 'EMP',
                    title: 'CORR',
                    isRtwEligible: true,
                },
                {
                    label: 'Medical certification form',
                    value: 'Medical certification form',
                    type: 'LVE',
                    title: 'MEDCERT',
                },
                {
                    label: 'Proof of birth',
                    value: 'Proof of birth',
                    type: 'LVE',
                    title: 'BRTHCERT',
                },
                {
                    label: 'Adoption/Foster care certification',
                    value: 'Adoption/Foster care certification',
                    type: 'LVE',
                    title: 'ADPTCERT',
                },
            ],
            spanish: [
                {
                    label: 'Formularios de autorización',
                    value: 'Formularios de autorización',
                    type: 'EMP',
                    title: 'AUTH',
                },
                {
                    label: 'Formularios firmados por los empleados',
                    value: 'Formularios firmados por los empleados',
                    type: 'EMP',
                    title: 'FORM',
                },
                {
                    label: 'Formularios firmados por el médico',
                    value: 'Formularios firmados por el médico',
                    type: 'MED',
                    title: 'FRMTRTNGPVDR',
                },
                {
                    label: 'Registros médicos',
                    value: 'Registros médicos',
                    type: 'MED',
                    title: 'MEDREC',
                },
                {
                    label: 'Otra documentación no médica',
                    value: 'Otra documentación no médica',
                    type: 'EMP',
                    title: 'CORR',
                },
                {
                    label: 'Formulario de certificación médica',
                    value: 'Formulario de certificación médica',
                    type: 'LVE',
                    title: 'MEDCERT',
                },
                {
                    label: 'Prueba de nacimiento',
                    value: 'Prueba de nacimiento',
                    type: 'LVE',
                    title: 'BRTHCERT',
                },
                {
                    label: 'Certificación de adopción/cuidado de crianza',
                    value: 'Certificación de adopción/cuidado de crianza',
                    type: 'LVE',
                    title: 'ADPTCERT',
                },
            ],
        },
        coordinatedER: {
            english: [
                {
                    label: 'Job description',
                    value: 'Job description',
                    type: 'EPR',
                    title: 'JOBDES'
                },
                {
                    label: 'Eligibility information',
                    value: 'Eligibility information',
                    type: 'EPR',
                    title: 'EPRELIG',
                },
                {
                    label: 'Employee signed forms',
                    value: 'Employee signed forms',
                    type: 'EMP',
                    title: 'FORM'
                },
                {
                    label: 'Medical records',
                    value: 'Medical records',
                    type: 'MED',
                    title: 'MEDREC'
                },
                {
                    label: 'Other non-medical documentation',
                    value: 'Other non-medical documentation',
                    type: 'EPR',
                    title: 'CORR',
                    isRtwEligible: true,
                },
                {
                    label: 'Medical certification form',
                    value: 'Medical certification form',
                    type: 'LVE',
                    title: 'MEDCERT'
                }
            ],
            spanish: [
                {
                    label: '',
                    type: '',
                    title: ''
                },
            ]
        },
        noCategory: {
            english: [
                {
                    label: 'No Categories',
                    value: 'No Categories',
                    type: '',
                    title: ''
                }
            ], spanish: [
                {
                    label: 'Sin categorías',
                    value: 'Sin categorías',
                    type: '',
                    title: ''
                }
            ],
        }
    },
    docsNet: {
        claimsEE: {
            english: [
                {
                    label: 'Authorization forms',
                    value: 'Authorization forms',
                    type: 'EMP',
                    title: 'AUTH',
                },
                {
                    label: 'Employee signed forms',
                    value: 'Employee signed forms',
                    type: 'EMP',
                    title: 'FORM',
                },
                {
                    label: 'Doctor signed forms',
                    value: 'Doctor signed forms',
                    type: 'MED',
                    title: 'FRMTRTNGPVDR',
                },
                {
                    label: 'Medical records',
                    value: 'Medical records',
                    type: 'MED',
                    title: 'MEDREC',
                    isRtwEligible: true,
                },
                {
                    label: 'Social Security documents',
                    value: 'Social Security documents',
                    type: 'SOC',
                    title: 'CORR',
                },
                {
                    label: 'Other non-medical documentation',
                    value: 'Other non-medical documentation',
                    type: 'EMP',
                    title: 'CORR',
                    isRtwEligible: true,
                },
            ],
            spanish: [
                {
                    label: 'Formularios de autorización',
                    value: 'Formularios de autorización',
                    type: 'EMP',
                    title: 'AUTH',
                },
                {
                    label: 'Formularios firmados por los empleados',
                    value: 'Formularios firmados por los empleados',
                    type: 'EMP',
                    title: 'FORM',
                },
                {
                    label: 'Formularios firmados por el médico',
                    value: 'Formularios firmados por el médico',
                    type: 'MED',
                    title: 'FRMTRTNGPVDR',
                },
                {
                    label: 'Registros médicos',
                    value: 'Registros médicos',
                    type: 'MED',
                    title: 'MEDREC',
                    isRtwEligible: true,
                },
                {
                    label: 'Documentos de seguridad social',
                    value: 'Documentos de seguridad social',
                    type: 'SOC',
                    title: 'CORR',
                },
                {
                    label: 'Otra documentación no médica',
                    value: 'Otra documentación no médica',
                    type: 'EMP',
                    title: 'CORR',
                    isRtwEligible: true,
                },
            ],
        }
    },
};
Object.assign(docMeta.s1, { intregatedLeaves: { ...docMeta.s1.claimsEE, ...docMeta.s1.leaves } });
